import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagEE = function FlagEE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "estonia"
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M174.878829,120 C162.523738,154.955772 129.186567,180 90,180 C50.8134331,180 17.4762623,154.955772 5.12117078,120 L174.878833,120 L174.878833,120 L174.878829,120 L174.878829,120 L174.878829,120 Z",
    id: "white",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M174.878829,120.000001 C178.195374,110.616633 180,100.519063 180,90 C180,79.480937 178.195374,69.3833673 174.878829,59.9999996 L5.12116698,60 C1.80462645,69.3833673 0,79.480937 0,90 C0,100.519063 1.80462645,110.616633 5.12117078,120 L174.878833,120 L174.878833,120 L174.878829,120.000001 L174.878829,120.000001 L174.878829,120.000001 Z",
    id: "black",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M174.878829,59.9999996 C162.523738,25.0442275 129.186567,0 90,0 C50.8134331,0 17.4762623,25.0442275 5.12117078,59.9999996 L174.878833,60 L174.878833,60 L174.878829,59.9999996 L174.878829,59.9999996 L174.878829,59.9999996 Z",
    id: "blue",
    fill: "#227FBB"
  })));
};

FlagEE.displayName = 'FlagEE';
export default withFlagWrapper(FlagEE);
//# sourceMappingURL=index.js.map